(function (root) {
  'use strict';
  var APP_ORIGIN = 'https://ev-guide-matrix.lovable.app';
  var SHOP_ORIGIN = 'https://evionor.hu';
  var PAGE_PATH = '/pages/elektromos-auto-tolto-osszehasonlito';
  var KEYS = ['vs', 'alap', 'view', 'diff', 'group', 'weights'];
  // Shopify reserves `view` for alternate Liquid templates. Keep it app-internal.
  function publicKey(key) { return key === 'view' ? 'compare_view' : key; }

  // The parent knows the transport schema; the application validates catalog IDs.
  function sanitize(input) {
    var result = {};
    if (!input || typeof input !== 'object' || Array.isArray(input)) return result;
    if (typeof input.vs === 'string' && input.vs.length <= 2000) {
      var ids = input.vs.split(',').filter(function (id) { return /^[a-z0-9_-]+$/i.test(id); });
      ids = ids.filter(function (id, index) { return ids.indexOf(id) === index; }).slice(0, 3);
      if (ids.length) result.vs = ids.join(',');
    }
    if (input.alap === 0 || input.alap === '0') result.alap = '0';
    if (input.view === 'all') result.view = 'all';
    if (input.diff === 1 || input.diff === '1') result.diff = '1';
    if (['charging', 'smart', 'safety', 'quality', 'ownership'].indexOf(input.group) !== -1) result.group = input.group;
    if (typeof input.weights === 'string' && input.weights.length <= 100) {
      var parts = input.weights.split(',');
      if (parts.length === 4 && parts.every(function (v) { return /^\d+(?:\.\d+)?$/.test(v) && Number(v) <= 100; }) && parts.some(function (v) { return Number(v) > 0; })) {
        result.weights = parts.map(Number).join(',');
      }
    }
    return result;
  }

  function readState(href) {
    var url = new URL(href);
    var values = {};
    KEYS.forEach(function (key) {
      var queryKey = publicKey(key);
      if (url.searchParams.has(queryKey)) values[key] = url.searchParams.get(queryKey);
    });
    return sanitize(values);
  }

  function stateUrl(state, embedded) {
    var url = new URL(embedded ? APP_ORIGIN + '/' : SHOP_ORIGIN + PAGE_PATH);
    if (embedded) url.searchParams.set('embed', '1');
    var clean = sanitize(state);
    KEYS.forEach(function (key) { if (clean[key] !== undefined) url.searchParams.set(embedded ? key : publicKey(key), clean[key]); });
    return url;
  }

  function mount(windowObject, container) {
    if (container.dataset.evComparatorMounted === '1') return;
    var location = new URL(windowObject.location.href);
    if (location.origin !== SHOP_ORIGIN || location.pathname !== PAGE_PATH) return;
    var frame = container.querySelector('[data-ev-comparator-frame]');
    var status = container.querySelector('[data-ev-comparator-status]');
    var fallback = container.querySelector('[data-ev-comparator-open]');
    if (!frame || !status || !fallback) return;
    container.dataset.evComparatorMounted = '1';
    var current = readState(location.href);
    var timer;

    function updateFallback() {
      var url = stateUrl(current, true);
      url.searchParams.delete('embed');
      fallback.href = url.href;
    }
    function init() {
      frame.contentWindow.postMessage({ type: 'evionor-comparator:init', version: 1, parentUrl: stateUrl(current, false).href }, APP_ORIGIN);
    }
    function loaded() {
      status.hidden = true;
      windowObject.clearTimeout(timer);
    }
    function receive(event) {
      if (event.origin !== APP_ORIGIN || event.source !== frame.contentWindow) return;
      var data = event.data;
      if (!data || typeof data !== 'object' || Array.isArray(data) || data.version !== 1) return;
      if (data.type === 'evionor-comparator:ready') {
        loaded();
        init();
      } else if (data.type === 'evionor-comparator:resize') {
        if (typeof data.height !== 'number' || !Number.isFinite(data.height) || data.height < 100 || data.height > 30000) return;
        frame.style.height = Math.ceil(data.height) + 'px';
        loaded();
      } else if (data.type === 'evionor-comparator:state') {
        if (!data.search || typeof data.search !== 'object' || Array.isArray(data.search)) return;
        current = sanitize(data.search);
        // Never navigate to the supplied shareUrl. Only our own path and schema are used.
        var next = new URL(windowObject.location.href);
        KEYS.concat(['embed', 'compare_view']).forEach(function (key) { next.searchParams.delete(key); });
        KEYS.forEach(function (key) { if (current[key] !== undefined) next.searchParams.set(publicKey(key), current[key]); });
        if (next.href !== windowObject.location.href) windowObject.history.replaceState(windowObject.history.state, '', next.href);
        updateFallback();
        loaded();
      }
    }
    function popstate() {
      current = readState(windowObject.location.href);
      frame.src = stateUrl(current, true).href;
      updateFallback();
    }
    function cleanup() {
      windowObject.clearTimeout(timer);
      windowObject.removeEventListener('message', receive);
      windowObject.removeEventListener('popstate', popstate);
      frame.removeEventListener('load', init);
      windowObject.removeEventListener('pagehide', pagehide);
      delete container.dataset.evComparatorMounted;
    }
    function pagehide(event) {
      // A page restored from the back/forward cache keeps its live connection.
      if (!event.persisted) cleanup();
    }
    windowObject.addEventListener('message', receive);
    windowObject.addEventListener('popstate', popstate);
    windowObject.addEventListener('pagehide', pagehide);
    frame.addEventListener('load', init);
    var src = stateUrl(current, true).href;
    if (frame.src !== src) frame.src = src;
    updateFallback();
    timer = windowObject.setTimeout(function () {
      if (!status.hidden) status.textContent = 'Lassan töltődik? Az összehasonlítót külön ablakban is megnyithatod.';
    }, 15000);
    init();
    return cleanup;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { sanitize: sanitize, readState: readState, stateUrl: stateUrl, mount: mount };
  if (root && root.document) {
    root.document.querySelectorAll('[data-ev-comparator]').forEach(function (container) { mount(root, container); });
  }
})(typeof window === 'undefined' ? null : window);
